function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedSeconds =
      seconds % 60 < 10 ? `0${seconds % 60}` : seconds % 60;
    return `${formattedMinutes}:${formattedSeconds}`;
}

export default formatTime;